import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Speaker } from 'api/speaker';
import { Popover, Switch } from 'antd';
import { useSession } from 'components/Authenticated';
import { txt } from 'libs/i18n';
import { QuoteIcon, QuoteHideIcon } from 'components/CustomIcons';
import IconButton from 'components/IconButton';
import clsx from 'clsx';
import { TIMESTAMP_WIDTH } from '../SpeakerTimestamp';
import styles from './style.module.less';
const ICON_WIDTH = 15;
const GAP = 5;
const SpeakerCitation = ({ position, widgetTrigger, disabled = false, editorController, }) => {
    const { session } = useSession();
    const isSpeakerIdEnabled = session.login.hasClaim('speakerId:enabled');
    if (!isSpeakerIdEnabled) {
        return null;
    }
    const isCitation = Speaker.getNotForTraining(widgetTrigger) === 'citation';
    const handleCitationChange = (value) => {
        editorController.handleSpeakerNotForTrainingChange(widgetTrigger, value ? 'citation' : null);
    };
    const hasTimestamp = widgetTrigger.querySelector('[data-timestamplabel]') !== null;
    const offset = hasTimestamp ? TIMESTAMP_WIDTH : 0;
    const left = position.isRightToLeft
        ? position.left - offset - ICON_WIDTH
        : position.left + position.width + offset + GAP;
    const tooltip = isCitation ? txt('speakerIsCited') : txt('speakerIsNotCited');
    return (_jsx("span", { className: styles.citation, style: { top: position.top, left }, children: _jsx(Popover, { content: (_jsxs("span", { className: styles.citationPopover, children: [txt('isSpeakerCited'), _jsx(Switch, { size: "small", checked: isCitation, disabled: disabled, onChange: handleCitationChange })] })), trigger: "click", destroyTooltipOnHide: true, open: disabled ? false : undefined, children: _jsx(IconButton, { tooltip: disabled ? tooltip : undefined, disabled: disabled, className: clsx(styles.icon, !isCitation && styles.iconNotCited), children: isCitation ? _jsx(QuoteIcon, {}) : _jsx(QuoteHideIcon, {}) }) }) }));
};
export default SpeakerCitation;
